

import { FC, PropsWithChildren } from 'react';

import { useFormatter } from '@eneco/i18n';
import { Stack, Text } from '@eneco/sparky';

import { generatePriceAriaLabel } from '../../helpers';

interface Props {
  id?: string;
  suffix?: string;
  emphasis?: 'medium' | 'low';
  previousValue?: string | number;
  children: string | number;
}

export const Price: FC<PropsWithChildren<Props>> = ({ id, emphasis, suffix, previousValue, children }) => {
  const { currency } = useFormatter();

  return (
    <Stack direction="column" alignX="end">
      <Stack direction={{ initial: 'column', md: 'row' }} gap={{ initial: '0', md: '3' }} alignX="end">
        {previousValue && (
          <Text size="BodyS" color="textLowEmphasis">
            <s>{currency.euro(previousValue)}</s>
          </Text>
        )}

        <Text weight={emphasis === 'low' ? 'regular' : 'bold'}>
          <span id={id} aria-label={generatePriceAriaLabel(currency.euro(children), suffix)}>
            {currency.euro(children)}
          </span>
        </Text>
      </Stack>

      {suffix && (
        <Text aria-hidden size="BodyS" color="textLowEmphasis">
          {suffix}
        </Text>
      )}
    </Stack>
  );
};

export const SMEPrice: FC<PropsWithChildren<Props>> = ({ id, emphasis, suffix, previousValue, children }) => {
  const { currency } = useFormatter();

  return (
    <Stack direction="row" gap={2} alignY="center">
      {previousValue && (
        <Text size="BodyS" color="textLowEmphasis">
          <s>{currency.euro(previousValue)}</s>
        </Text>
      )}

      <Text weight={emphasis === 'low' ? 'regular' : 'bold'}>
        <span id={id} aria-label={generatePriceAriaLabel(currency.euro(children), suffix)}>
          {currency.euro(children)}
        </span>
      </Text>
      {suffix && (
        <Text as="span" aria-hidden size="BodyS" color="textLowEmphasis">
          {suffix}
        </Text>
      )}
    </Stack>
  );
};
